import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsComponent } from './tabs.component';
import { TabOptionsComponent } from './components/tab-options.component';
import { TabOptionComponent } from './components/tab-option.component';
import { TabPanelsComponent } from './components/tab-panels.component';
import { TabPanelComponent } from './components/tab-panel.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TabsComponent,
    TabOptionsComponent,
    TabOptionComponent,
    TabPanelsComponent,
    TabPanelComponent,
  ],
  exports: [
    TabsComponent,
    TabOptionsComponent,
    TabOptionComponent,
    TabPanelsComponent,
    TabPanelComponent,
  ],
})
export class AppTabsModule {}
